import React from 'react';
import PropTypes from 'prop-types';
import { Editor } from '@splashthat/splash-cms-engine';

import TouchpointContainer from 'common/components/TouchpointEditor/components/TouchpointContainer';
import { stateSubsetForEquality } from 'common/components/TouchpointEditor/utils/stateSubsetForEquality';

import AgendaContent from './AgendaContent';

const EditorTools = React.lazy(() => import('./sidebar/Sidebar'));
const TopBar = React.lazy(() => import('./TopBar/EditorTopBar'));
const PreviewTopBar = React.lazy(() => import('./TopBar/PreviewTopBar'));

export const AgendaGuestExperienceContainer = React.memo(({ isEditing, shouldPreview, hideFooter }) => (
    <Editor editing={isEditing} stateSubsetForEquality={stateSubsetForEquality}>
        <React.Suspense fallback={null}>
            {isEditing && <TopBar />}
            {shouldPreview && <PreviewTopBar />}
        </React.Suspense>
        <React.Suspense fallback={null}>
            <TouchpointContainer editing={isEditing}>
                <AgendaContent hideFooter={hideFooter} />
                {isEditing && <EditorTools />}
            </TouchpointContainer>
        </React.Suspense>
    </Editor>
));

AgendaGuestExperienceContainer.propTypes = {
    isEditing: PropTypes.bool.isRequired,
    shouldPreview: PropTypes.bool.isRequired,
    hideFooter: PropTypes.bool.isRequired,
};
